<template>
  <div class="text-xs-center" justify="center">
    <v-dialog
      v-model="modal.active"
      :fullscreen="standalone"
      height="100%"
      hide-overlay
      transition="dialog-bottom-transition"
      >
      <v-card v-if="modal.active" style="height: 100vh; ">
        <v-card-title style="height: 90px; margin-top: -30px; overflow: hidden">
          <v-layout
            flex
            wrap
            justify-space-between>
            <v-flex xs7>
              <h2>{{ strings[idioma].ajuda }}</h2>
            </v-flex>
            <v-flex xs1>
              <v-divider
                vertical
                inset/>
            </v-flex>
            <v-flex class="flex xs2 layout align-center justify-end">
              <v-layout
                v-if="!standalone"
                justify-end
                align="center">
                <v-btn
                  color="primary"
                  flat
                  rounded
                  outlined
                  @click="modal.active = false; openNovaJanela()">
                  <v-icon>mdi-open-in-new</v-icon>
                  &nbsp;{{ strings[idioma].abrir_nova_guia }}
                </v-btn>
              </v-layout>
            </v-flex>
            <v-flex class="flex xs2 layout align-center justify-end">
              <v-layout
                v-if="!standalone"
                justify-end
                align="center">
                <v-btn
                  color="error"
                  rounded
                  outlined
                  @click="modal.active = false">
                  X
                </v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider/>
        <v-card-text>
          <v-layout
            flex
            wrap
            justify-space-between>
            <v-flex
              sm8
              xs12
              style="overflow: auto; position: relative; padding: 10px;">
              
              
              
              <Video
                :src="ajuda.video"
                style="position: relative; width: 100%; height: 98%"
                :onFinish="nextVideo"></Video>
              
              
                
            </v-flex>
            <v-flex
              sm4
              xs12
              style="overflow: auto; position: relative; padding: 10px;">
              <v-layout
                v-show="maisInfo"
                style="position: absolute; z-index: 999; background-color: #ccc; opacity: 0.9; height: 100vh; width: 100vw; padding: 10px;"
                flex
                wrap
                justify-space-between>  
                <v-flex xs12>
                  <v-textarea
                    :value="ajuda.descricao"
                    readonly/>
                </v-flex>
                
                <v-flex xs12>
                  <v-textarea
                    v-model="report.msg"
                    outline
                    :label="strings[idioma].reporte_um_erro_duvida"/>
                  <v-btn
                    color="black"
                    dark
                    style="width:100%"
                    @click="reportar()">{{ strings[idioma].enviar }}</v-btn>
                </v-flex>
                <div
                  style="position: absolute; z-index: 999; right: 10px;">
                  <v-btn icon color="error" @click="maisInfo = false">X</v-btn>
                </div>
              </v-layout>
                <h3>{{ ajuda.titulo }}</h3>
                <div
                  v-if="!maisInfo"
                  style="opacity: 0.7; background: #000;">
                  <v-btn flat dark small color="error" @click="maisInfo = true">Reportar Erro ou Dúvida</v-btn>
                  <v-btn flat dark small @click="maisInfo = true">Ver Detalhes</v-btn>
                </div>
                <ul style="min-height: 450px; overflow:auto">
                  <li><b>{{ strings[idioma].outros_videos }}</b></li>
                  <li
                    v-for="(a, index) in ajudas"
                    :key="index"
                    @click="(ajuda && ajuda.id !== a.id) ? ajuda = a : null">
                    <a
                      v-if="ajuda && ajuda.id !== a.id"
                      href="javascript:void(0);">📺 {{ a.id }} - {{ a.titulo }}</a>
                    <i v-else> {{ a.id }} - {{ a.titulo }} </i>
                  </li>
                </ul>
                

              
              
              
            </v-flex>
            
            
            
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {
  mapMutations,
  mapState
} from 'vuex'
import html2canvas from 'html2canvas'
import Video from './Video'
import { base64DecodeSanitarize } from '../../utils/utils'
export default {
  props: {
    standalone: {
      type: Boolean,
      default: () => false
    },
  },
  data: () => ({
    modal: {
      active: false,
      video: null,
      stop: false
    },
    report: {
      msg: null,
      rota: null,
      etapa: null,
      video: null,
      captura: null
    },
    ajudas: null,
    ajuda: null,
    logo: 'img/brcorte-logo.png',
    maisInfo: false
  }),
  computed: {
    ...mapState('app', ['step', 'user', 'trava_back', 'curr_version', 'strings', 'idioma'])
  },
  components: {
    Video
  },
  created () {
    this.axios.post('ajuda', { web: true }).then((res) => {
      this.ajudas = res.data.data
      this.ajuda = this.ajudas[0]
      if (this.$route.query.a) {
        this.ajuda = JSON.parse(base64DecodeSanitarize(this.$route.query.a))
      }
    })
    document.querySelector('html').classList.add('no-overflow')
  },
  methods: {
    openNovaJanela () {
      const win = window.open(`/instrucoes?a=${btoa(JSON.stringify(this.ajuda))}`, '_blank')
      if (!win) {
        window.location.href=`/instrucoes?a=${btoa(JSON.stringify(this.ajuda))}`
      }
    },
    open () {
      this.modal.active = true
    },
    close () {
      this.modal.active = false
    },
    openHelp () {
      // this.modal.captura = canvas.toDataURL('image/jpeg')
      this.modal.user = this.user
      this.modal.rota = this.$route.path
      this.modal.step = this.step
      this.modal.video = '/assets/videos/fd.mp4'
      if (this.ajudas === null) {
        this.axios.post('ajuda', { web: true }).then((res) => {
          this.ajudas = res.data.data
          this.ajuda = this.ajudas[0]
          return this.openHelp()
        })
      } else {
        let ajudaTeste = this.ajudas.filter(a => a.rota === this.modal.rota || '/' + a.rota === this.modal.rota)
        if (ajudaTeste && ajudaTeste.length > 0) {
          if (this.modal.step !== null) {
            let re = ajudaTeste.filter(a => a.etapa === this.modal.step)
            if (re && re.length > 0) {
              ajudaTeste = re
            }
            re = ajudaTeste.filter(a => a.idioma === this.idioma)
            if (re && re.length > 0) {
              ajudaTeste = re
            }
          }
          this.ajuda = ajudaTeste[0]
        }
        this.modal.active = true
      }
      if (this.$route.query.a) {
        this.ajuda = JSON.parse(base64DecodeSanitarize(this.$route.query.a))
      }
      console.log(this.modal)

      html2canvas(document.querySelector('body')).then(canvas => {
        console.log(canvas)
        document.body.appendChild(canvas)
        var a = document.createElement('a')
        // toDataURL defaults to png, so we need to request a jpeg, then convert for file download.
        this.modal.captura = canvas.toDataURL('image/jpeg')
        this.modal.user = this.user
        this.modal.rota = this.$route.path
        this.modal.step = this.step
        this.modal.video = '/assets/videos/fd.mp4'
        let ajudaTeste = []
        if (this.ajudas !== null) ajudaTeste = this.ajudas.filter(a => a.rota === this.modal.rota || '/' + a.rota === this.modal.rota)
        if (ajudaTeste && ajudaTeste.length > 0) {
          if (this.modal.step !== null) {
            let re = ajudaTeste.filter(a => a.etapa === this.modal.step)
            if (re && re.length > 0) {
              ajudaTeste = re
            }
          }
          this.ajuda = ajudaTeste[0]
        }
        this.modal.active = true
        console.log(this.modal)

        a.href = canvas.toDataURL('image/jpeg').replace('image/jpeg', 'image/octet-stream')
        a.download = 'somefilename.jpg'
        // a.click()
      })
    },
    nextVideo () {
      this.maisInfo = true
    },
    reportar () {
      this.report.user = this.user
      this.report.rota = this.$route.path
      this.report.etapa = this.step
      this.report.video = this.modal.video
      this.report.captura = this.modal.captura
      let dados = {
        id_ajuda: this.ajuda.id,
        descricao: this.report.msg,
        captura: this.report.captura,
        dados: this.report,
        id_pessoa: this.report.user.id,
        web: true
      }
      this.axios.post('ajuda/reportar', dados).then(res => {
        let msg = this.strings[this.idioma].reportado_com_sucesso
        let title = ''
        this.$store.commit('openOKModal', { title, msg })
        this.report.msg = null
        // this.close()
      }).finally(_ => {
        this.maisInfo = false
      })
    }
  }
}
</script>
